<template>
  <div>
    <boton-atras :nombre_ruta="'MenuArmonizacion'"/>
    <div class="container text-center mb-5">
        <h1 class="bold300 text-uppercase" style=" font-weight:500;">Documentos Publicados Chiapas</h1>
    </div>
    <div class="col-12">
        <px-select2
          class="w-100"
          idSelect="docPublicConac"
          placeholder="Seleccione el año"
          :options="data"
          @KuramaSelect="(selected = $event),   (textoTitulo = selected.text)"
        ></px-select2>
    </div>
    <tabla-simple id="tabla1Filtros" class="mt-5" :titulo="textoTitulo" :datos="selected" />
    <span v-if="selected" v-html="fecha_actualizacion"></span>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContable from "@/services/ArmonizacionContable/ArmonizacionContable.service.js";
const _serviciosArmonizacionContable = new ArmonizacionContable();
import botonAtras from './../button-atras'

import DateFormat from "@/mixins/dateFormatMixin.js";
import tablaSimple from '@/components/tablaSimple.vue';
import PxSelect2 from '@/views/PxSelect.vue'

export default {
    name: 'DocumentosPublicadosChiapas',
    components: { botonAtras, tablaSimple, PxSelect2 },
    mixins: [DateFormat],
    data() {
        return {
          data: [],
          textoTitulo: '',
          selected: '',
        };
    },
    async created() {
        await this.getDocumentosPublicadosChiapas();
    },
    methods: {
        async getDocumentosPublicadosChiapas() {
            try {
                const response = await _serviciosArmonizacionContable.getDocumentosPublicadosChiapas(mapFun.documentosPublicadosChiapas);
                this.data = response.data[0];
                this.fecha_actualizacion = this.DateFormatText(this.data.fecha_actualizacion);
                this.data = this.data.contenido.map(function (e) {
                return {
                    id:       e.id,
                    text:     e.titulo +' '+ e.pieTitulo,
                    seccion:  e.contenido
                };
              });
            } catch (error) {
                console.log('error', error.message);
            }
        }
    }
}
</script>

